import React from 'react'
import { useResponsive } from '../hooks'
import { Skeleton, TextSkeleton } from '.'

export const ArticleCardSkeleton = () => {
  const { breakpoints } = useResponsive()

  return (
    <>
      <Skeleton
        shade="light"
        height={breakpoints.min.LG ? 410 : undefined}
        className="c-article-card">
        <div className="u-pt-16 u-px-16">
          <Skeleton shade="dark" borderRadius={0} className="c-article-card__hero" />
        </div>
        <div className="u-w-100 u-px-16 u-py-16">
          <TextSkeleton type="h3" />
          <TextSkeleton type="p" />
        </div>
      </Skeleton>
    </>
  )
}
